import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import KeywordHistoryResultModal from '@/components/container/modal/article/KeywordHistoryResultModal'

interface KeywordHistoryResultModalState {
  siteId: number
  historyId: number | null
  onApply(keyword: string): void
}

const defaultValue: KeywordHistoryResultModalState = {
  siteId: 0,
  historyId: null,
  onApply: () => undefined
}

export const KeywordHistoryResultModalContext =
  createModalContext<KeywordHistoryResultModalState>(defaultValue)

const KeywordHistoryResultModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<KeywordHistoryResultModalState>(defaultValue)
  return (
    <KeywordHistoryResultModalContext.Provider value={state}>
      {children}
      <KeywordHistoryResultModal />
    </KeywordHistoryResultModalContext.Provider>
  )
}

export default KeywordHistoryResultModalProvider
